// src/redux/authSlice.js
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { login, forgetPassword, changePassword } from "../Apis/login";

// Get token from localStorage to initialize the state
const initialState = {
  user: null,
  user_id: null,
  isAuthenticated: false,
  loading: false,
  error: null,
  token: localStorage.getItem("token"), // Retrieve token from localStorage
};

export const checkLoginStatus = createAsyncThunk(
  "user/checkLoginStatus",
  async (_, thunkAPI) => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        return { token }; // If token exists, return it
      } catch (error) {
        localStorage.removeItem("token");
        return thunkAPI.rejectWithValue("Invalid token");
      }
    } else {
      return thunkAPI.rejectWithValue("No token found");
    }
  }
);

export const loginUser = createAsyncThunk(
  "user/login",
  async (credentials, thunkAPI) => {
    try {
      const response = await login(credentials.email, credentials.password);
      localStorage.setItem("token", response.token); // Store token in localStorage
      localStorage.setItem("access", response.result.access); // Store token in localStorage
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Login failed");
    }
  }
);

export const forgetUser = createAsyncThunk(
  "user/forgotpassword",
  async (credentials, thunkAPI) => {
    try {
      const response = await forgetPassword(credentials.email);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Login failed");
    }
  }
);
export const passwordChange = createAsyncThunk(
  "user/changepassword",
  async ({ user_id, password, newpassword }, thunkAPI) => {
    try {
      const response = await changePassword(user_id, password, newpassword);
      return response; // Successfully changed password
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Password change failed"
      );
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginFailed(state, action) {
      state.error = action.payload?.message || "Login failed";
    },
    logout: (state) => {
      state.token = null;
      state.isAuthenticated = false;
      localStorage.removeItem("token");
      localStorage.removeItem("access");
      state.error = null;
      state.user = null;
      state.user_id = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.user = action.payload.result;
        state.user_id = action.payload.result._id;
        state.token = action.payload.token; // Save token from response
        state.access = action.payload.access; // Save token from response
        state.isAuthenticated = true;
        state.loading = false;
        state.error = null;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.error = action.payload; // Capture error message
        state.loading = false;
      })
      .addCase(checkLoginStatus.fulfilled, (state, action) => {
        state.token = action.payload.token; // Save token from localStorage or API response
        state.isAuthenticated = true;
        state.loading = false;
        state.error = null;
      })
      .addCase(checkLoginStatus.rejected, (state, action) => {
        state.error = action.payload; // Capture error message
        state.loading = false;
      })

      .addCase(passwordChange.fulfilled, (state, action) => {
        state.token = null;
        state.isAuthenticated = false;
        localStorage.removeItem("token");
        localStorage.removeItem("access");
        state.error = null;
        state.user = null;
        state.user_id = null;
      });
  },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;
